import PropTypes from 'prop-types';
import { Box, Card, CardHeader, Skeleton, Stack } from '@mui/material';

// Placeholder con la MISMA caja que la gráfica real, para que el layout no salte al cargar.
// Las medidas están copiadas de los componentes que reemplaza:
//   - 'line' → AppBalance: <Box p:3 pb:1> + ReactApexChart height={364}
//   - 'pie'  → AppCurrentVisits: ChartWrapperStyle (height 372, marginTop spacing(5), legend 72)
// Si cambias la altura allí, cámbiala aquí.
const VARIANTS = {
  line: { height: 364 },
  pie: { height: 372, legendHeight: 72 },
};

// Las cards de gráfica van sobre primary.light, así que el gris por defecto del Skeleton
// desaparece: usamos blancos translúcidos.
const SHIMMER = 'rgba(255, 255, 255, 0.24)';
const SHIMMER_SOFT = 'rgba(255, 255, 255, 0.16)';

ChartCardSkeleton.propTypes = {
  variant: PropTypes.oneOf(['line', 'pie']),
  hasSubheader: PropTypes.bool,
};

export default function ChartCardSkeleton({ variant = 'line', hasSubheader = true }) {
  const { height, legendHeight } = VARIANTS[variant];

  return (
    <Card sx={{ bgcolor: (theme) => theme.palette.primary.light, height: '100%' }}>
      <CardHeader
        title={<Skeleton variant="text" width={140} height={24} sx={{ bgcolor: SHIMMER }} />}
        subheader={hasSubheader && <Skeleton variant="text" width={240} height={16} sx={{ bgcolor: SHIMMER_SOFT }} />}
      />

      {variant === 'pie' ? (
        <Box sx={{ height, mt: 5, px: 3 }}>
          <Stack alignItems="center" justifyContent="center" sx={{ height: height - legendHeight }}>
            <Skeleton variant="circular" width={220} height={220} sx={{ bgcolor: SHIMMER_SOFT }} />
          </Stack>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{ height: legendHeight, borderTop: (theme) => `solid 1px ${theme.palette.divider}` }}
          >
            {[64, 56, 72, 48].map((w) => (
              <Skeleton key={w} variant="text" width={w} height={14} sx={{ bgcolor: SHIMMER }} />
            ))}
          </Stack>
        </Box>
      ) : (
        <Box sx={{ p: 3, pb: 1 }}>
          <Skeleton variant="rectangular" height={height} sx={{ bgcolor: SHIMMER_SOFT, borderRadius: 1 }} />
        </Box>
      )}
    </Card>
  );
}
